import React, { createContext, useContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Inicializa buscando as chaves específicas do QuitaGo
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('@QuitaGo:user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [role, setRole] = useState(() => localStorage.getItem('@QuitaGo:role') || null);
  
  const [authenticated, setAuthenticated] = useState(() => !!localStorage.getItem('@QuitaGo:token'));

  const login = (userData, userRole, token) => {
    // 1. Salva com os nomes que o seu api.js (Interceptor) espera
    localStorage.setItem("@QuitaGo:token", token);
    localStorage.setItem("@QuitaGo:role", userRole);
    localStorage.setItem("@QuitaGo:user", JSON.stringify(userData));

    // 2. Atualiza o estado
    setUser(userData);
    setRole(userRole);
    setAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("@QuitaGo:token");
    localStorage.removeItem("@QuitaGo:role");
    localStorage.removeItem("@QuitaGo:user");

    setUser(null);
    setRole(null);
    setAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ authenticated, user, role, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth deve ser usado dentro de um AuthProvider");
  }
  return context;
};